/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_RefreshInputs */

const en_settings_refresh = /** @type {(inputs: Settings_RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refresh contacts`)
};

const he_settings_refresh = /** @type {(inputs: Settings_RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`רענון אנשי קשר`)
};

/**
* | output |
* | --- |
* | "Refresh contacts" |
*
* @param {Settings_RefreshInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const settings_refresh = /** @type {((inputs?: Settings_RefreshInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_RefreshInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_refresh(inputs)
	return he_settings_refresh(inputs)
});